/*
 * Filename: d:\projects\AutoFiFront\src\Content\CarCost\CarCost.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Friday, January 13th 2023, 2:10:45 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

import { CarCostPropsType } from "Content/Car/CarCost/CarCost.type";
import styles from "Content/Car/CarCost/CarCost.module.css";
import CarCostBg from "Theme/Component/CarCost";
import CarCostSellPrice from "Theme/Component/CarCostSellPrice";
import { useAuth } from "Router/AuthProvider";

function CarCost(props: CarCostPropsType) {
    const { isConnected } = useAuth();
    const carCost = props.carCost;

    return (
        <div className={`${styles.car_costDisplay}`}>
            <CarCostBg bgColor={props.themeColor}>
                <p className={`${styles.car_rental_cost}`}><span style={{fontSize:"1.5rem"}}>{props.CustomText}</span></p>
            </CarCostBg>
            {
                carCost && isConnected ?
                <div className={`${styles.car_cost}`}>
                    <CarCostSellPrice fontColor={props.themeColor}>
                        <p className={`${styles.resetMargPad}`}>{carCost}€</p>
                    </CarCostSellPrice>
                </div>
                :null
            }
        </div>
    );
}

export default CarCost;
